var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterManagement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    style: {
      enableBackground: "new 0 0 23 23"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2064B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 18.6,
    cy: 5.2,
    r: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.5,7.9c-0.1-0.1-0.1-0.1-0.1-0.2c-1.5,0.2-2.8,1.5-2.8,3.1v0.8h3.5l-0.3-0.6c0-0.1,0-0.2,0-0.2l0.4-2.2 L17.5,7.9z M19.7,7.6c0,0.1,0,0.2-0.1,0.2L19,8.5l0.4,2.2c0,0.1,0,0.2,0,0.2L19,11.5h3.5v-0.8C22.5,9.1,21.3,7.8,19.7,7.6L19.7,7.6 z M13.1,2.9l1.3-2.4H7.1l1.3,2.4H13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.9,10.7L13.9,10.7l-5.9,0c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h5.9c0,0,0.1,0,0.1,0 c0.3-1.2,1.1-2.2,2.2-2.8c-0.5-0.6-0.7-1.2-0.7-2c0-1.7,1.4-3.1,3.1-3.1V1.3c0-0.4-0.4-0.8-0.8-0.8h-2.5l-1.6,2.9 c-0.1,0.1-0.2,0.2-0.3,0.2H8.1C8,3.7,7.9,3.6,7.8,3.4L6.2,0.5H3.7c-0.4,0-0.8,0.4-0.8,0.8v10.4c0.4-0.1,0.8-0.2,1.2-0.2 c1.6,0,3.1,0.9,3.8,2.4c0,0,0,0,0.1,0h6.3c0.2,0,0.4,0.2,0.4,0.4s-0.2,0.4-0.4,0.4H8.2c0.1,0.4,0.2,0.8,0.2,1.2 c0,0.7-0.2,1.4-0.5,2h6.4c0.2,0,0.4,0.2,0.4,0.4s-0.2,0.4-0.4,0.4H7.4c-0.8,1-2,1.6-3.3,1.6c-0.4,0-0.8-0.1-1.2-0.2v1.7 c0,0.4,0.4,0.8,0.8,0.8h14.1c0.4,0,0.8-0.4,0.8-0.8v-9.4h-4.7V10.7z M8,6h6.3c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4H8 c-0.2,0-0.4-0.2-0.4-0.4C7.6,6.2,7.8,6,8,6z M4.6,5.3c0.2-0.2,0.4-0.2,0.6,0c0,0,0,0,0,0l0.5,0.5l1.3-1.3c0.2-0.2,0.4-0.2,0.6,0 s0.2,0.4,0,0.6L5.9,6.7c-0.2,0.2-0.4,0.2-0.6,0c0,0,0,0,0,0L4.6,5.9C4.4,5.7,4.4,5.5,4.6,5.3C4.6,5.3,4.6,5.3,4.6,5.3z M5.9,10.6 c-0.2,0.2-0.4,0.2-0.6,0c0,0,0,0,0,0L4.6,9.8c-0.2-0.2-0.2-0.4,0-0.6c0.2-0.2,0.4-0.2,0.6,0l0.5,0.5l1.3-1.3c0.2-0.2,0.4-0.2,0.6,0 s0.2,0.4,0,0.6L5.9,10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.2,16.2c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h0.4c-0.2-1.6-1.5-2.9-3.1-3.1v0.4 C4.4,12.9,4.3,13,4,13c-0.2,0-0.4-0.2-0.4-0.4v-0.4c-1.6,0.2-2.9,1.5-3.1,3.1h0.4c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4H0.5 c0.2,1.6,1.5,2.9,3.1,3.1V19c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4l0,0v0.4c1.6-0.2,2.9-1.5,3.1-3.1H7.2z M5.9,14.5 l-1.6,1.6c-0.1,0.1-0.2,0.1-0.3,0.1H2.5c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h1.4l1.5-1.5c0.1-0.2,0.4-0.2,0.6,0 C6.1,14.1,6.1,14.3,5.9,14.5C5.9,14.5,5.9,14.5,5.9,14.5L5.9,14.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterManagement);
export default __webpack_public_path__ + "static/media/master-management.14d1dd468921d7c5118a638fb15ba691.svg";
export { ForwardRef as ReactComponent };